import { Helpers } from '../../helpers';
import { IFenceType } from '../../interfaces/ifence-type';
import { ProjectPondParameter } from '../project-pond-parameter';

export class FenceTypeBase {
  FenceTypeId: number;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectPondParameters_FenceType?: Array<ProjectPondParameter> | null;

  constructor(item?: IFenceType) {
    if (item) {

      this.FenceTypeId = item.FenceTypeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectPondParameters_FenceType = Helpers.createClassArray(ProjectPondParameter, item.ProjectPondParameters_FenceType);
    }
  }
}